import { Environment } from './types';

export const firebaseApiKey = 'AIzaSyBkaEhcwVUJG5tNx9o0UkY_7G2ZMCkhVJE';
export const rollbarToken = '5cdd738c57014cd79e6019f0b748a730';

/* eslint-disable */
export const environment: Environment = {
  production: false,
  development: false,
  localLogin: true,
  name: 'demo',
  products: {
    connect: 'https://connect-test.ideta.io',
    default: 'https://app-test.ideta.io',
    webhooks: 'https://webhooks-test.ideta.io',
    livechat: 'https://livechat-test.ideta.io',
    inbox: 'https://inbox-test.ideta.io',
    autocomment: 'https://private-replies-test.ideta.io'
  },
  domain: 'https://inbox-test.ideta.io',
  backendUrl: 'https://api-test.ideta.io',
  useSupportBot: false,
  firebase: {
    authDomain: 'app-test.ideta.io',
    databaseURL: 'https://trhs-sandbox1.firebaseio.com',
    projectId: 'trhs-sandbox1',
    storageBucket: 'trhs-sandbox1.appspot.com',
    messagingSenderId: '1059659963313'
  },
  facebook: {
    appId: '291291871593091',
    url: 'https://graph.facebook.com/v16.0',
    xfbml: true,
    cookie: true,
    logging: true,
    scopes: ['public_profile', 'email', 'pages_messaging', 'pages_show_list', 'pages_manage_metadata', 'pages_read_engagement']
  },
  rollbar: {
    active: true,
    buildVersion: 'd11c7b3'
  },
  deploymentServices: [
    {
      name: 'Sandbox',
      type: 'sandbox',
      logo: 'assets/img/deployment-services/sandbox.png'
    },
    {
      name: 'Web / Livechat',
      type: 'web',
      logo: 'assets/img/deployment-services/web.png'
    },
    {
      name: 'Facebook',
      type: 'facebook',
      logo: 'assets/img/deployment-services/facebook.png',
      inboxLink: true
    },
    {
      name: 'Instagram',
      type: 'instagram',
      logo: 'assets/img/deployment-services/facebook.png',
      inboxLink: true
    },
    {
      name: 'Google Home',
      type: 'google',
      logo: 'assets/img/deployment-services/google_home.png'
    },
    {
      name: 'Slack',
      type: 'slack',
      logo: 'assets/img/deployment-services/slack.png'
    },
    {
      name: 'Workplace',
      type: 'workplace',
      logo: 'assets/img/deployment-services/workplace.jpeg'
    },
    {
      name: 'Smooch',
      type: 'smooch',
      logo: 'assets/img/deployment-services/smooch.png'
    },
    {
      name: 'Twilio Voice',
      type: 'twiliovoice',
      logo: 'assets/img/deployment-services/twilio.png'
    },
    {
      name: 'Skype',
      type: 'skype',
      logo: 'assets/img/deployment-services/skype.png'
    },
    {
      name: 'Teams',
      type: 'teams',
      logo: 'assets/img/deployment-services/teams.png'
    },
    {
      name: 'Business Messages',
      type: 'businessmessages',
      logo: 'assets/img/deployment-services/businessmessages.png'
    },
    {
      name: 'Whatsapp',
      type: 'whatsapp',
      logo: 'assets/img/deployment-services/whatsapp.png'
    },
    {
      name: 'Discord',
      type: 'discord'
    },
    {
      name: 'Whatsapp Direct',
      type: 'whatsappDirect',
      logo: 'assets/img/deployment-services/whatsapp.png'
    },
    {
      name: 'Api',
      type: 'api',
      logo: 'assets/img/deployment-services/api.png'
    },
    {
      name: 'AudioCodes',
      type: 'audiocodes',
      logo: 'assets/img/deployment-services/audiocodes.png'
    },
    {
      name: 'HighConnexion',
      type: 'highConnexion',
      logo: 'assets/img/deployment-services/highConnexion.png',
      beta: true
    },
    {
      name: 'Time2Chat',
      type: 'time2chat',
      logo: 'assets/img/deployment-services/highConnexion.png',
      beta: true
    },
    {
      name: 'AI Community Manager',
      type: 'aicm',
      logo: 'assets/img/deployment-services/facebook.png'
    },
    {
      name: 'Genesys voice',
      type: 'genesysVoice',
      logo: 'assets/img/deployment-services/genesysVoice.png'
    },
    {
      name: 'Email (IMAP)',
      type: 'imap',
      logo: 'assets/img/deployment-services/imap.png'
    }
  ],
  appSettings: {
    billingTrialDuration: 20160,
    maxPaginatedUserListLength: 50,
    maxLastUserListLength: 100,
    typingVisualDelay: 1500,
    emptyTemplateImg: 'https://img.icons8.com/pastel-glyph/2x/empty-box.png',
    maxKeyNameLength: 100,
    maxPropertyNameLength: 100,
    delayBeforeCokcpitNodeResend: 5000,
    noNameNode: 'bulle_sans_nom',
    apiMaxTimeout: 10000,
    defaultTextSpeechLang: 'en_US',
    voiceNumberThreshold: 100000,
    maxKeepAliveDelay: 1440,
    systemKeyAsIdentifier: ['first_name', 'last_name', 'email', 'phone_number', 'avatar'],
    maxOperationsDisplayOnInit: 5,
    maxKeysDisplayOnInit: 15,
    maxDataKeyLength: 80,
    maxDataKeyLines: 11,
    maxExpandedWorkspaces: 5,
    minHeight: 500,
    minWidth: 500,
    notificationDelay: 30,
    cockpitNotificationDelay: 1,
    testing: {
      threeColsRatio: 157,
      twoColsRatio: 120
    },
    cockpit: {
      rowsPerPageConversationList: [25, 50, 100],
      socketActiveTimeout: 1800000,
      supportActiveTimeout: 1800000,
      maxNumberOfKeys: 100,
      userDisplayLength: 18,
      debounceTimeMessages: 200,
      dataListShortWidth: '160px'
    },
    analytics: {
      daylyMaxInterval: 7776000000,
      weeklyMaxInterval: 15552000000,
      monthlyMaxInterval: 63244800000
    },
    embedded: {
      blurEventCode: 'v2bnpga',
      displayNotificationCode: 'z64tefu',
      resetNotificationCode: 'dj9y4b8',
      triggerInPageNavigationCode: 'k120eks',
      startEventCode: 'k257yt6',
      loadedEventCode: 's737sz2'
    },
    templates: {
      buttons: {
        maxElements: 4
      },
      quickReplies: {
        maxElements: 20
      },
      media: {
        maxElements: 1,
        maxButtonsPerElement: 1
      },
      carrousel: {
        imageMaxHeight: 17,
        maxElements: 10,
        maxButtonsPerElement: 3
      },
      list: {
        minElements: 2,
        maxElements: 10,
        maxButtonsPerElement: 1,
        maxButtons: 1
      },
      openGraph: {
        maxElements: 1,
        maxButtons: 1
      }
    },
    lexicons: {
      syncTimeWaitMs: 900000
    }
  },
  defaults: {
    user: {
      avatarUrl: 'assets/img/avatar.svg'
    }
  },
  oneSignal: {
    appId: '94ee2920-5b42-4737-8a2f-c58f18723724',
    safari_web_id: 'web.onesignal.auto.28be2e0f-48c0-43fd-877a-95cc3c6fc0d9'
  }
};
/* eslint-enable */
